import { useStandardProductAmountCalculator } from "app/hooks/shared/standard-product/useStandardProductAmountCalculator";
import { useEffect, useState } from "react";
import FormGroup from "shared/ui/FormGroup";
import Icon, { IconTypes } from "shared/ui/icon";
import Input from "shared/ui/input";
import Label from "shared/ui/label";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

const SHOW_MESSAGE_AFTER_CM = 268;

interface Props {
  setStandardProductAmount: (amount: number) => void;
}

const StandardProductAmountCalculator = ({
  setStandardProductAmount,
}: Props) => {
  const [calcWidth, setCalcWidth] = useState(60);
  const [calcHeight, setCalcHeight] = useState(268);

  const amount = useStandardProductAmountCalculator(
    calcWidth * 10, // to transform to mm
    calcHeight * 10, // to transform to mm
  );

  useEffect(() => {
    if (amount) {
      setStandardProductAmount(amount);
    }
  }, [amount]);

  return (
    <div className="gg-grid gg-grid-cols-12 gg-gap-3 gg-pt-1.5">
      <FormGroup className="gg-col-span-12 sm:gg-col-span-6 lg:gg-col-span-12 xl:gg-col-span-6">
        <Label htmlFor="calc-width-input" className="gg-mb-1" required>
          Breedte in cm
        </Label>
        <Input
          id="calc-width-input"
          type="number"
          min={1}
          onChange={(e) => setCalcWidth(parseInt(e.target.value) || 0)}
          value={calcWidth.toString()}
          required
        />
      </FormGroup>

      <FormGroup className="gg-col-span-12 sm:gg-col-span-6 lg:gg-col-span-12 xl:gg-col-span-6">
        <Label htmlFor="calc-height-input" className="gg-mb-1" required>
          Hoogte in cm
        </Label>
        <Input
          id="calc-height-input"
          type="number"
          min={1}
          value={calcHeight.toString()}
          onChange={(e) => setCalcHeight(parseInt(e.target.value) || 0)}
          required
        />

        {calcHeight > SHOW_MESSAGE_AFTER_CM && (
          <Text className="gg-mt-2 gg-text-sm gg-text-red">
            Let op: de panelen hebben een standaard lengte van 268cm.
          </Text>
        )}
      </FormGroup>

      {calcHeight > SHOW_MESSAGE_AFTER_CM && (
        <div className="gg-col-span-12 gg-flex gg-flex-col gg-items-start gg-gap-4 gg-bg-gray-100 gg-p-4 sm:gg-flex-row">
          <Icon
            name={IconTypes.EXCLAMATION_MARK_ROUND}
            className="gg-h-7 gg-w-7 gg-shrink-0"
          />
          <div>
            <Heading headingLevel="h5" className="gg-mb-4 gg-text-sm">
              De opgegeven wandhoogte is hoger dan onze panelen van 268cm.
            </Heading>
            <Text className="gg-text-sm">
              Is jouw wand hoger en wil je deze volledig met akoestische panelen
              bekleden? Neem dan eerst contact met ons op.
            </Text>
          </div>
        </div>
      )}

      {amount !== undefined && (
        <Text className="gg-col-span-12 gg-mt-3 gg-rounded gg-bg-yellow-300 gg-px-2 gg-py-2">
          Wij denken dat jij{" "}
          <span className="gg-font-bold">
            {amount} {amount > 1 ? "panelen" : "paneel"}
          </span>{" "}
          nodig hebt
        </Text>
      )}
    </div>
  );
};
export default StandardProductAmountCalculator;
